module.exports = __webpack_public_path__ + "static/media/191EC253.d24c28be.jpg";